import { render } from "./JobsView.vue?vue&type=template&id=2b315196&scoped=true"
import script from "./JobsView.vue?vue&type=script&lang=js"
export * from "./JobsView.vue?vue&type=script&lang=js"

import "./JobsView.vue?vue&type=style&index=0&id=2b315196&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b315196"

export default script